import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/caprock_merchant.png'


const _withScopeId = n => (_pushScopeId("data-v-1c428f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "sticky" }, [
  /*#__PURE__*/_createElementVNode("nav", { class: "navbar navbar-expand-lg navbar-light" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "navbar-container" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        onclick: "location.href='https://caprock.com.au'"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          onclick: "location.href='https://caprock.com.au'",
          src: _imports_0,
          class: "img-fluid",
          style: {"display":"inline","height":"50px"}
        })
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.load_on==1)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_1
  ], 64))
}